import React from "react";
import {createPortal} from "react-dom";

export const ContextMenu = ({positions, floatingRef, floatingStyles}) => {

    const renderPositions = () => {
        return (
            <div className={'context-menu-wrapper'}>
                {positions.map((position) => (
                    <div key={position.id}>
                        {position.id === 'details' && (<div className={'draggable-position-separator'}/>)}
                        <div className={'context-menu-position'} onClick={position.handler}>
                            {position.icon}
                            <span style={position.id === 'remove' ? {color: "#EC5858"} : {}}>
                                {position.name}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return createPortal(
        <div className={'context-menu'}
             ref={floatingRef}
             style={{
                 ...floatingStyles,
                 zIndex: 9999,
             }}>
            {renderPositions()}
        </div>,
        document.body);
};